<template>
  <div class="row grid--gtm-portfolio">
    <SolutionBox :slug="slug" v-for="solution in boxes" :solution="solution" :key="solution.idSolution"></SolutionBox>
  </div>
</template>

<script>
import SolutionBox from "@/components/solutions/SolutionBox";
export default {
name: "SolutionGrid",
  props: ['boxes', 'slug'],
  components: {SolutionBox}
}
</script>

<style scoped>

</style>